import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { ObjectTypes } from '@fi-shared/types/object-type';
import {
    AppearanceModuleSideListOptions,
    IAppearanceModuleSideListOption,
} from '../../apeparance-module-side-list-options';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { ListViewSettingModel } from '@fi-app/components/items-list/list-view-setting.model';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiDisplayType } from '@fi-shared/types/display-type';
// not used component
@Component({
    selector: 'fi-appearance-list-view-view',
    templateUrl: './list-view-view.component.html',
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-appearance-list-view-view' },
    standalone: false,
})
export class FiAppearanceListViewViewComponent implements OnInit {
    @Input() listViewSettings: ListViewSettingModel[];

    protected readonly FiDisplayType = FiDisplayType;

    get documentListViewSettings() {
        return this.listViewSettings.find((item) => item.ObjectType === ObjectTypes.Document);
    }
    get mediaListViewSettings() {
        return this.listViewSettings.find((item) => item.ObjectType === ObjectTypes.MediaBank);
    }
    get userListViewSettings() {
        return this.listViewSettings.find((item) => item.ObjectType === ObjectTypes.User);
    }

    @Input() appearanceSidebarStateModel;

    ObjectTypes = ObjectTypes;
    selectedSideListOption: IAppearanceModuleSideListOption;
    sideListOptions = AppearanceModuleSideListOptions;
    editTabs: EditTabsModel;

    constructor(
        private detectDevice: DetectDevicesService,
        private appTextService: AppTextService,
        private stateService: FiStateService,
    ) {}

    get showAppearanceEdit(): boolean {
        return !this.detectDevice.isMobilePhone();
    }

    ngOnInit() {
        this.editTabs = new EditTabsModel(
            this.appTextService.get('common.listView'),
            undefined,
            this.appTextService.get('common.edit'),
        );
        this.setSideListSettings();
    }

    private setSideListSettings() {
        this.selectedSideListOption = this.sideListOptions[0];

        this.sideListOptions.forEach((option: IAppearanceModuleSideListOption) => {
            if (option.previewTemplateName === this.appearanceSidebarStateModel.modulePreviewTemplateName) {
                this.selectedSideListOption = option;
            }
        });
    }

    selectSideListOption(sideListOption: IAppearanceModuleSideListOption) {
        this.appearanceSidebarStateModel.modulePreviewTemplateName = sideListOption.previewTemplateName;
        this.selectedSideListOption = sideListOption;
    }

    isSideListOptionSelected(sideListOption: IAppearanceModuleSideListOption): boolean {
        return sideListOption.objectType === this.selectedSideListOption.objectType;
    }

    editListView() {
        this.stateService.go(FiStateNames.Appearance.ListView.Edit);
    }
}
